import {
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/client/components/shad/sidebar";

import { createFileRoute } from "@tanstack/react-router";
import { SkopaStatus } from "./-features/SkopaStatus";

import { SkopaArm } from "./-features/SkopaArm";

import { SkopaFilters } from "./-features/SkopaFilters";
import { SkopaTargets } from "./-features/SkopaTargets";
import { SkopaSilos } from "./-features/SkopaSilos";
import { ScrollArea } from "@/client/components/shad/scroll-area";
import { Separator } from "@/client/components/shad/separator";

export const Route = createFileRoute("/(protected)/map/skopa/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <SidebarHeader className="text-sm border-b px-3 py-3">
        <SkopaStatus />
      </SidebarHeader>
      <SidebarContent className="p-3 space-y-1 flex flex-col text-xs">
        <SkopaFilters />
        <Separator />
        <ScrollArea className="grow flex flex-col h-[50vh] -mr-3 pr-3">
          <div className="grow h-full">
            <SkopaTargets />
          </div>

          <SkopaSilos />
        </ScrollArea>
      </SidebarContent>
      <SidebarFooter className="pb-2 border-t">
        <SkopaArm />
      </SidebarFooter>
    </>
  );
}
